import React, { useState } from "react"
import OptionsDropdown from "./OptionsDropdown"
import { StatusMessage } from "components/ui"
import PropTypes from "prop-types"
import useOptionsUpdate from "./useOptionsUpdate"
import useStatus from "./useStatus"
import { ModalContextProvider } from "../modals/Modal"

const SelectionTypesOptionsWrapper = ({
  signup: signupFromProps,
  status: statusFromProps,
  signupTimes,
  handleOptionsUpdate: handleOptionsUpdateFromProps,
  registerForSeparateTimesEnabled,
  canChangeRegisterForSeparateTimes
}) => {
  const [signup] = handleOptionsUpdateFromProps
    ? [signupFromProps, undefined]
    : useState(signupFromProps)
  const status = statusFromProps || useStatus()
  const handleOptionsUpdate = handleOptionsUpdateFromProps || useOptionsUpdate({ signup, status })

  return (
    <div className="d-f ai-c g-1">
      {!statusFromProps && status.get().type === "success" && <StatusMessage {...status.get()} />}
      <ModalContextProvider>
        <OptionsDropdown
          signup={signup}
          onSaveClick={handleOptionsUpdate}
          status={status.get()}
          signupTimes={signupTimes}
          registerForSeparateTimesEnabled={registerForSeparateTimesEnabled}
          canChangeRegisterForSeparateTimes={canChangeRegisterForSeparateTimes}
        />
      </ModalContextProvider>
    </div>
  )
}

SelectionTypesOptionsWrapper.propTypes = {
  signup: PropTypes.object,
  status: PropTypes.shape({
    get: PropTypes.func,
    setSaving: PropTypes.func,
    SetSuccess: PropTypes.func,
    setError: PropTypes.func
  }),
  signupTimes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      availableForRegistrations: PropTypes.bool
    })
  ),
  handleOptionsUpdate: PropTypes.func,
  registerForSeparateTimesEnabled: PropTypes.bool,
  canChangeRegisterForSeparateTimes: PropTypes.bool
}

export default SelectionTypesOptionsWrapper
